import { useIntl } from 'react-intl';

import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';
import { FeatureType } from 'common/types';

type UseIsCampaignEnabledProps = {
  feature: FeatureType;
  featureId: string;
  entityCountry: string;
};

export const useIsCampaignEnabled = ({ feature, featureId, entityCountry }: UseIsCampaignEnabledProps) => {
  const { isEmployee, user } = useUser();
  const intl = useIntl();
  const eligibilityCriteria = {
    is_employee: isEmployee.toString(),
    user_id: user?.id || '',
    user_email: user?.email || '',
    user_country: user?.country || '',
    user_locale: intl.locale,
    feature,
    ...(featureId ? { feature_id: featureId } : {}),
    ...(entityCountry ? { feature_country: entityCountry } : {}),
  };

  const { data: featureFlags, isLoading } = useFeatureFlags(['merchant_campaigns'], eligibilityCriteria, {
    enabled: !!user,
  });

  return {
    isCampaignsEnabled: !isLoading && featureFlags?.merchant_campaigns === 'on',
  };
};
